var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMediaTab = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.875 10.5156C0.875 12.125 1.6875 12.9375 3.32812 12.9375H3.75V6.10938C3.75 3.89062 4.92188 2.74219 7.15625 2.74219H17.1719V2.60938C17.1719 1 16.3516 0.1875 14.7266 0.1875H3.32812C1.6875 0.1875 0.875 1 0.875 2.60938V10.5156ZM7.27344 16.5547H18.6719C20.2969 16.5547 21.1172 15.7422 21.1172 14.1328V6.22656C21.1172 4.61719 20.2969 3.80469 18.6719 3.80469H7.27344C5.63281 3.80469 4.82031 4.60938 4.82031 6.22656V14.1328C4.82031 15.7422 5.63281 16.5547 7.27344 16.5547ZM10.2812 10.0469C9.29688 10.0469 8.5 9.25 8.5 8.27344C8.5 7.30469 9.29688 6.5 10.2812 6.5C11.25 6.5 12.0469 7.30469 12.0469 8.27344C12.0469 9.25 11.25 10.0469 10.2812 10.0469ZM7.1875 15.25C6.49219 15.25 6.125 14.8828 6.125 14.1797V13.5391L7.4375 12.3516C8.11719 11.7266 8.51562 11.3047 9.05469 11.3047C9.60938 11.3047 10.0547 11.7422 10.7578 12.3516L11.4688 12.9844L14.4453 10.2891C15.1484 9.65625 15.5234 9.45312 16.0312 9.45312C16.5234 9.45312 16.8906 9.66406 17.5547 10.3281L19.8203 12.5703V14.1797C19.8203 14.875 19.4453 15.25 18.75 15.25H7.1875Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMediaTab);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-media-tab.35ed385886361954067fc3a8fb86b7cb.svg";